// import { Link } from 'react-router-dom';

import { LayoutPropsType } from '../type';

export const useLayout = (props: LayoutPropsType) => {
    return {
        rootProps: props,
    };
};
